import { exportExcel } from "@api/stores/employeeActivities/exportExcel/path";
import { exportPDF } from "@api/stores/employeeActivities/exportPDF/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/employee-activities/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const employeeActivities = {
  getAll: apiPathFunc(pathBase),
  exportPDF,
  exportExcel,
};
